de:
  close: Schliessen
fr:
  close: Fermer
it:
  close: Chiudere
